import type { DiscoveryGetTrends200Page } from './discoveryGetTrends200Page';

export type DiscoveryGetTrends200 = {
  code?: string;
  message?: string;
  page?: DiscoveryGetTrends200Page;
  success?: boolean;
};
